export default __webpack_public_path__ + "static/nanno_screen_2-1b4a1c4a9cbaa22437dfb4978d7b9c6a.svg";